import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Input, OnChanges, Optional, Output, Self, signal, SimpleChanges, ViewChild, WritableSignal } from '@angular/core';
import { DialogComponent } from "../dialog/components/dialog.component";
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { ControlBase } from '../base/control.base';
import { SelectedItem } from '../models/selected-item.interface';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { FormsModule, NgControl } from '@angular/forms';
import { ItemListSelectorPipe } from 'src/app/common/components/navigation-bar/competitions/competition-details/competition-registration/pipes/additional-competitor.pipe';
import { CecBreakpointPipe } from '../pipes/cec-breakpoint.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'cec-item-list-selector',
  templateUrl: './item-list-selector.component.html',
  styleUrls: ['./item-list-selector.component.scss'],
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, TranslateModule, MatListModule, MatIconModule, MatButtonModule, FormsModule, ItemListSelectorPipe, CecBreakpointPipe, CommonModule, MatTooltipModule],
  host: {
    style: 'width: 100% !important',
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemListSelectorComponent extends ControlBase<number[]> implements OnChanges {

    private detector = inject(ChangeDetectorRef);

    protected noOptions = false;

    private _disableDeleteIfSingle: WritableSignal<boolean> = signal(false);

    /** Disables delete button when there is only single item selected */
    @Input() set disableDeleteIfSingle(value: boolean) {
        this._disableDeleteIfSingle.set(value);
    }

    /** Gets the disable button state */
    get disableDeleteIfSingle(): boolean {
        return this._disableDeleteIfSingle();
    }

    constructor(@Optional() @Self() public ngControl: NgControl) {
        super(ngControl);
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.options) {
            this.items = this.options?.filter(option => this.value?.includes(option.value));
            this.disableSelect();
        }
    }

    @Input() protected options: SelectedItem[] = [];

    protected items: SelectedItem[] = [];

    protected selectedItem: number | undefined = undefined;

    protected updated = new Date();

    protected getControlValue(): number[] {
        return this.value;
    }

    protected setControlValue(val: number[]): void {
        if (!val || !val.length) {
            this.items = [];
            this.selectedItem = null;
            this.disableSelect();
            this.detector.detectChanges();
            return null;
          }
      
          this.items = this.options?.filter(option => val.includes(option.value));
          this.value = [];
          val.forEach(item => this.value.push(item));
          this.disableSelect();
          this.detector.detectChanges();
    }

    protected setControlDisabled(isDisable: boolean): void {
        this.isDisabled.set(isDisable);
    }

    protected addItem(event: MatSelectChange): void {
        this.updated = new Date();
        const item = this.options.find(option => option.value === event.value);
        this.items.push(item);
        this.writeValue(this.items.map(item => item.value));
        this.propagateValue();
    }

    protected removeItem(item: SelectedItem): void {
        this.updated = new Date();
        this.items.splice(this.items.indexOf(item), 1);
        this.selectedItem = undefined;
        this.writeValue(this.items.map(item => item.value));
        this.propagateValue();
    }

    protected disableSelect(): void {
        this.noOptions = !!this.options?.filter(item1 => !this.items.some(item2 => item2.value === item1.value)).length;
    }
}
